import { inject } from "vue";
import { AcquaintApiClient } from "@/services/AcquaintApiClient";
import displayErrorMessage from "@/utils/ErrorHandling";
import { getErrorMessage } from "bright-logic-core/src/errors";
import {
  SummaryStatementItem,
  SummaryStatementRequest,
} from "@/types/financials/SummaryStatement";
import {
  DeleteFeeRequest,
  OneOffFeeRequest,
} from "@/types/financials/OneOffFeeRequest";
import { SummaryStatementPdfRequest } from "@/types/financials/SummaryStatementPdfRequest";
import { PropertyContactPdfRequest } from "@/types/financials/PropertyContactPdfRequest";

export function useFinancialHelper() {
  const acquaintApiClient = inject<AcquaintApiClient>("AcquaintApiClient")!;

  return {
    getSummaryStatements: async (request: SummaryStatementRequest) => {
      try {
        return await acquaintApiClient.httpPost<SummaryStatementItem[]>(
          `app/summarystatements/getsummarystatements`,
          request,
        );
      } catch (ex) {
        displayErrorMessage(getErrorMessage(ex));
      }
    },

    createOneOffFee: async (request: OneOffFeeRequest) => {
      try {
        await acquaintApiClient.httpPostVoid(
          `app/summarystatements/createoneofffee`,
          request,
        );
      } catch (err) {
        displayErrorMessage(getErrorMessage(err));
      }
    },

    deleteTransactionBatch: async (request: DeleteFeeRequest) => {
      try {
        await acquaintApiClient.httpPostVoid(
          `app/summarystatements/DeleteTransactionBatch`,
          request,
        );
      } catch (err) {
        displayErrorMessage(getErrorMessage(err));
      }
    },

    generatePdfAllSummaryStatements: async (
      request: SummaryStatementPdfRequest,
    ) => {
      try {
        return await acquaintApiClient.getFileWithPostData(
          `app/summarystatements/generateallsummarystatementspdf`,
          request,
        );
      } catch (err) {
        displayErrorMessage(getErrorMessage(err));
      }
    },

    generatePdfForpropertycontact: async (
      request: PropertyContactPdfRequest,
    ) => {
      try {
        return await acquaintApiClient.getFileWithPostData(
          `app/summarystatements/generatesummarystatementforpropertycontactpdf`,
          request,
        );
      } catch (err) {
        displayErrorMessage(getErrorMessage(err));
      }
    },
  };
}
